import { GlobalSearchScopeIdentifier, GlobalSearchScopeKind } from "client/Api/TitleBar/GlobalSearch/globalSearch";
import { createBrowserNavigationUrl, route } from "client/Navigation";
import { SearchPageQueryParams } from "./SearchPage";
import { never } from "client_legacy/ndaw/errors";
import { isNotNil } from "client/Misc/utils";

export const searchRouting = {
	page: route<undefined, SearchPageQueryParams>`/Search`,
};

export type ReactRouterUrlOptions = {
	searchTerm?: string;
	scope?: GlobalSearchScopeIdentifier | null;
	groupId?: number;
};

export function getSearchUrl(
	options: ReactRouterUrlOptions
): string {
	return createBrowserNavigationUrl(
		searchRouting.page({
			queryParams: getSearchQueryParams(options)
		})
	);
}

export function getSearchQueryParams(
	options: ReactRouterUrlOptions
): SearchPageQueryParams {
	const {
		searchTerm,
		scope,
		groupId
	} = options;

	const queryParams: SearchPageQueryParams = {
		searchTerm,
		groupId: undefined,
		integrationId: undefined,
		scope: undefined
	};

	if (scope) {
		switch(scope.kind) {
			case GlobalSearchScopeKind.Predefined:
				queryParams.scope = `${scope.predefinedKind}`;
				break;
			case GlobalSearchScopeKind.IntegrationFlow:
				queryParams.integrationId = `${scope.integrationId}`;
				break;
			default:
				never(scope);
		}
	}

	if (isNotNil(groupId)) {
		queryParams.groupId = `${groupId}`;
	}

	return queryParams;
}
